import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { noop } from 'lodash';

import { MATERIAL_COLORS } from './colors';

type OnChangeFunction = (value: string) => void;
type OnTouchFunction = () => void;

@Component({
  selector: 'la-color-picker',
  styleUrls: ['./color-picker.component.scss'],
  templateUrl: './color-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true,
    },
  ],
})
export class ColorPickerComponent implements ControlValueAccessor {
  private cd = inject(ChangeDetectorRef);

  readonly colorSchema: string[][] = MATERIAL_COLORS;
  color?: string;

  onChange: OnChangeFunction = noop;
  onTouch: OnTouchFunction = noop;

  registerOnChange(fn: OnChangeFunction): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: OnTouchFunction): void {
    this.onTouch = fn;
  }

  writeValue(input: string) {
    this.selectColor(input);
  }

  onClick(color: string) {
    this.selectColor(color);
  }

  isColorSelected(color: string) {
    if (!this.color) return false;
    return color.localeCompare(this.color, undefined, { sensitivity: 'base' }) === 0;
  }

  private selectColor(color: string) {
    this.color = color;
    this.onChange(this.color);
    this.cd.markForCheck();
  }
}
